
import ViewModel from '@/models/ViewModel'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class PopoverList extends ViewModel {
  @Prop({ default: false }) public disabled!: boolean

  @Prop({ required: true }) public list!: any

  @Prop({ required: true }) public item!: any

  @Prop({ default: false }) public title!: any

  public id: any = this.randomUUID()

  public openPopOver: boolean = false

  public open() {
    this.openPopOver = true
  }

  public close() {
    this.openPopOver = false
    this.$root.$emit('bv::hide::popover', `popover-list-${this.item.id}`)
  }

  public selected({ value }: any) {
    if (value === this.item.status) {
      this.close()
      return
    }
    this.$emit('selected', value)
    this.close()
  }
}
